// src/reducers/pbhorder.reducer.js

import { getStatusesConstants } from "../constants";

export function statusesOrder(state = null, action) {
  if (action && action.type) {
    switch (action.type) {
      case getStatusesConstants.STATUSES_ORDERS_REQUEST:
        return {};
      case getStatusesConstants.STATUSES_ORDERS_SUCCESS:
        return { status: action.orders.status };
      case getStatusesConstants.STATUSES_ORDERS_FAILURE:
        return {};

      default:
        return state;
    }
  }
}
